import { useNavigate, useLocation } from "react-router-dom";
import { InstagramLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: id } });
    else scrollToId(id);
  };

  const links = [
    { label: "Inicio", action: () => go("top") },
    { label: "Colecciones", action: () => go("colecciones") },
    { label: "Preguntas frecuentes", action: () => go("faq") },
    { label: "Contacto", action: () => go("contacto") },
    { label: "Blog", action: () => navigate("/blog") },
  ];

  return (
    <footer data-testid="footer" className="bg-[#2D3732] text-[#E7EAE2] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="leading-none">
              <span className="font-display text-3xl text-white">VITAE</span>
              <span className="block overline mt-1 text-[#A3B18A]">by Ana</span>
            </div>
            <p className="font-display text-2xl text-white/90 mt-6 max-w-sm leading-snug">
              Tu salud y tu orden cuentan.
            </p>
            <p className="text-sm text-white/50 mt-4 max-w-sm leading-relaxed">
              No vendemos carpetas. Ofrecemos tranquilidad y organización para el cuidado de tu salud.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40 mb-5">Navegación</p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={l.action}
                    className="text-sm text-white/70 hover:text-[#A3B18A] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/40 mb-5">Contacto</p>
            <div className="space-y-4">
              <a
                href="mailto:vitaebyana@gmail.com"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-[#A3B18A] transition-colors"
              >
                <EnvelopeSimple size={20} weight="light" /> vitaebyana@gmail.com
              </a>
              <a
                href="https://instagram.com/vitaebyana"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-[#A3B18A] transition-colors"
              >
                <InstagramLogo size={20} weight="light" /> @vitaebyana
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 text-xs text-white/40">
          <p>© {new Date().getFullYear()} VITAE by Ana. Todos los derechos reservados.</p>
          <div className="flex gap-6">
            <button className="hover:text-white/70 transition-colors">Política de privacidad</button>
            <button className="hover:text-white/70 transition-colors">Aviso legal</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
